import React, { useMemo } from 'react';
import { Flex, List, useScreenSize } from '@banhala/ui-kit';
import { useAtomicProxyComponent } from './queries/useAtomicProxyComponent';
import { useLikeMap, useOutfitBookmarkMap } from '../../../../hooks';
import { AtomicComponent } from '../../utils/createAtomicComponent';

const ProxyContent: React.FC<{
  screenName?: string;
  screen?: string;
  body: {
    item: {
      url: string;
    };
  };
  logDisabled?: boolean;
}> = props => {
  const { data: proxyComponent, isSuccess } = useAtomicProxyComponent(
    props.body.item.url,
  );
  const { likeMap, setLikeMap } = useLikeMap();
  const { bookmarkMap, setBookmarkMap } = useOutfitBookmarkMap({
    initialMap: {},
  });

  if (!isSuccess) return null;

  return (
    <Flex>
      {proxyComponent?.components.map((component, index) => {
        return (
          <Flex key={`atomic-proxy-item-${index}`}>
            <AtomicComponent
              component={component}
              index={index}
              likeMap={likeMap}
              setLikeMap={setLikeMap}
              bookmarkMap={bookmarkMap}
              setBookmarkMap={setBookmarkMap}
              screen={props.screen}
              logDisabled={props.logDisabled}
              screenName={props.screenName}
            />
          </Flex>
        );
      })}
    </Flex>
  );
};

const ProxySkeleton = () => {
  const { width: screenWidth } = useScreenSize();

  const cardWidth = useMemo(() => {
    return (screenWidth - 2) / 3;
  }, [screenWidth]);

  return (
    <Flex>
      <Flex.Row
        padding={{ horizontal: 16, vertical: 16 }}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Flex
          backgroundColor={'bg_tertiary'}
          width={98}
          height={24}
          borderRadius={4}
        ></Flex>
        <Flex
          backgroundColor={'bg_tertiary'}
          width={64}
          height={18}
          borderRadius={4}
        ></Flex>
      </Flex.Row>
      <Flex>
        <List<number>
          data={Array.from({ length: 9 }, (_, index) => index)}
          numColumns={3}
          columnWrapperStyle={{ gap: 2 }}
          renderItem={({ item }) => {
            return (
              <Flex flex={1} position={'relative'} key={item}>
                <Flex
                  width={cardWidth}
                  height={cardWidth * 1.2}
                  backgroundColor={'bg_tertiary'}
                />
                <Flex margin={{ top: 4, bottom: 20 }} gap={2}>
                  <Flex
                    width={cardWidth * 0.8}
                    height={20}
                    backgroundColor={'bg_tertiary'}
                  />
                  <Flex
                    width={cardWidth * 0.9}
                    height={16}
                    backgroundColor={'bg_tertiary'}
                  />
                  <Flex
                    width={cardWidth * 0.4}
                    height={14}
                    margin={{ top: 4 }}
                    backgroundColor={'bg_tertiary'}
                  />
                </Flex>
              </Flex>
            );
          }}
        />
      </Flex>
    </Flex>
  );
};

export const Proxy: React.FC<{
  screen?: string;
  body: {
    item: {
      url: string;
    };
  };
  logDisabled?: boolean;
}> = props => {
  return (
    <React.Suspense fallback={<ProxySkeleton />}>
      <ProxyContent {...props} />
    </React.Suspense>
  );
};
